// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  height: 100%;
}

a {
  color: #f31f90;
  font-weight: bold;
  text-decoration: none;
}

#root {
  height: 100%;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.web3modal-provider-wrapper {
  padding: 0 !important;
}

.web3modal-provider-wrapper > div {
  border-radius: 0;
}

.web3modal-provider-wrapper:hover {
  background-color: rgb(37, 37, 37);
}

.web3modal-provider-wrapper-disabled {
  pointer-events: none;
}

.web3modal-provider-wrapper-loading::before {
  content: ' ';
  position: absolute;
  z-index: 1;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  border: 0.25rem solid rgba(255, 255, 255, 0.2);
  border-top-color: rgba(255, 255, 255);
  animation: spin 1s infinite linear;
}

.web3modal-provider-wrapper-loading::after {
  background-color: rgba(97, 97, 97, 0.4);
  position: absolute;
  z-index: 2;
  height: 100%;
  width: 100%;
  content: ' ';
}

.web3modal-provider-wrapper-loading {
  position: relative;
}

.web3modal-modal-lightbox {
  z-index: 8 !important;
}

.web3modal-modal-card {
  grid-template-columns: unset !important;
  max-width: 400px !important;
}

@media only screen and (min-width: 960px) {
  .web3modal-modal-lightbox {
    padding-left: 200px !important;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  height: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  height: 100%;\n}\n\na {\n  color: #f31f90;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n#root {\n  height: 100%;\n}\n\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.web3modal-provider-wrapper {\n  padding: 0 !important;\n}\n\n.web3modal-provider-wrapper > div {\n  border-radius: 0;\n}\n\n.web3modal-provider-wrapper:hover {\n  background-color: rgb(37, 37, 37);\n}\n\n.web3modal-provider-wrapper-disabled {\n  pointer-events: none;\n}\n\n.web3modal-provider-wrapper-loading::before {\n  content: ' ';\n  position: absolute;\n  z-index: 1;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  border: 0.25rem solid rgba(255, 255, 255, 0.2);\n  border-top-color: rgba(255, 255, 255);\n  animation: spin 1s infinite linear;\n}\n\n.web3modal-provider-wrapper-loading::after {\n  background-color: rgba(97, 97, 97, 0.4);\n  position: absolute;\n  z-index: 2;\n  height: 100%;\n  width: 100%;\n  content: ' ';\n}\n\n.web3modal-provider-wrapper-loading {\n  position: relative;\n}\n\n.web3modal-modal-lightbox {\n  z-index: 8 !important;\n}\n\n.web3modal-modal-card {\n  grid-template-columns: unset !important;\n  max-width: 400px !important;\n}\n\n@media only screen and (min-width: 960px) {\n  .web3modal-modal-lightbox {\n    padding-left: 200px !important;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
